import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../../EmptyFragment';
import { OpenableState } from '../../../../../../../../../Modal/UseOpenable';
import { SectionContext } from '../../../../../../../Types';
import Store from '../../../../Store';
import { AlreadyTranslatedText } from '@execonline-inc/translations';
import LearningCollectionEditStore from '../../../../../../../Edit/Store';
import { ExperienceResource } from '../../../../Types';
import AddLearningJourney from './AddLearningJourney';

interface ModelProps {
  modalState: OpenableState;
  context: SectionContext;
  store: Store;
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  close: () => void;
  resource: ExperienceResource;
}

function WarningModel({
  context,
  learningCollectionStore,
  learningDesignName,
  store,
  modalState,
  close,
  resource,
}: ModelProps) {
  switch (modalState.kind) {
    case 'closed':
      return emptyFragment();
    case 'open':
      return (
        <AddLearningJourney
          store={store}
          context={context}
          learningCollectionStore={learningCollectionStore}
          learningDesignName={learningDesignName}
          close={close}
          resource={resource}
        />
      );
  }
}

export default observer(WarningModel);
